import * as React from 'react';
import classNames from 'classnames';
import './index.less';

export interface MessageBoxProps {
  prefixCls?: string;
  className?: string;
  header?: React.ReactNode;
  content?: React.ReactNode;
  style?: React.CSSProperties;
  /** 显示在左侧还是右侧 */
  type?: 'left' | 'right';
}

export default class MessageBox extends React.Component<MessageBoxProps, any> {
  public static defaultProps = {
    prefixCls: 'mpc-message-box',
    type: 'left',
  };
  public render() {
    const { prefixCls, className, header, content, type, ...others } = this.props;
    const classes = classNames(className, {
      [`${prefixCls}`]: true,
      [`${prefixCls}-${type}`]: !!type,
    });
    return (
      <div className={classes} {...others}>
        <div className={`${prefixCls}-header`}>{header}</div>
        <div className={`${prefixCls}-content`}>{content}</div>
      </div>
    );
  }
}
